// @ts-ignore
import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import FirstStep from "../components/FirstStep";
import GoogleMe from "../components/GoogleMe";
import Testimony from "../components/Testimony";
import BookCall from "../components/BookCall";
import Footer from "../components/Footer";
import AuthorityBuilderFunnel from "../components/AuthorityBuilderFunnel";

function Home() {
  <main>
  <title>Empowering Women Entrepreneurs with Web Design & SEO | Her Growth Co.</title>
<meta
name="description"
content="Her Growth Co helps female founders grow their brands with conversion-optimized web design, SEO strategies, and digital visibility services tailored to women-led businesses."
/>
<meta
name="keywords"
content="web design austin tx, seo services austin, premium website design austin, austin seo expert, custom web design for consultants austin, austin seo for creatives, authority website design austin, high-end seo agency austin, austin local seo services, web design for coaches austin, conversion-focused web design austin, bespoke websites austin, seo for service providers austin, austin high-ticket web design, expert seo strategy austin, website design agency austin, austin tx web design for women, seo for women-led businesses austin, women entrepreneur seo austin, austin website agency for female founders, mobile-first web design austin, seo content strategy austin, interactive website design austin tx, austin digital marketing agency, high-converting websites austin, seo consultant for women austin, austin brand visibility seo."
/>
</main>

  return (
    <div>

    <Hero/>
    <About/>
    <Services/>
    <FirstStep/>
    <GoogleMe/>
    <Testimony/>
    <BookCall/>
    <AuthorityBuilderFunnel/>
    <Footer/>


      {/* Book Now */}

      {/* Footer */}
     


    </div>
  );
// </main>
}

export default Home;
